import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

function calcAge(birthday) {
  if (!birthday) return '-'
  const birth = new Date(birthday)
  const now = new Date()
  let age = now.getFullYear() - birth.getFullYear()
  const m = now.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age--
  return age > 0 ? age : '-'
}

export default function Members() {
  const [children, setChildren] = useState([])
  const [pointsMap, setPointsMap] = useState({})
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')

  useEffect(() => {
    fetch(`${API}/children`)
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          const kids = d.data || []
          setChildren(kids)
          // 批量拉取积分
          Promise.all(kids.map(c =>
            fetch(`${API}/points/${c.id}`).then(r => r.json())
          )).then(results => {
            results.forEach((r, i) => {
              if (r.success && r.data) {
                map[kids[i].id] = r.data
              }
            })
            setPointsMap(map)
          }).catch(e => { console.error(e) })
        }
      })
      .finally(() => setLoading(false))
  }, [])

  const filtered = children.filter(c => {
    if (!search) return true
    const s = search.toLowerCase()
    return c.name?.includes(search)
      || c.parent_name?.includes(search)
      || (c.parent_contact || '').includes(search)
  })

  const totalPoints = Object.values(pointsMap).reduce((s, p) => s + (p.balance || 0), 0)

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>会员管理</h2>

      <div style={{ display: 'flex', gap: 16, marginBottom: 20 }}>
        <div style={{ ...statCard, borderLeft: '4px solid #722ed1' }}>
          <div style={{ color: '#999', fontSize: 12 }}>孩子总数</div>
          <div style={{ fontSize: 24, fontWeight: 600 }}>{children.length}</div>
        </div>
        <div style={{ ...statCard, borderLeft: '4px solid #fa8c16' }}>
          <div style={{ color: '#999', fontSize: 12 }}>活跃机构</div>
          <div style={{ fontSize: 24, fontWeight: 600 }}>{new Set(children.map(c => c.institution_id)).size}</div>
        </div>
        <div style={{ ...statCard, borderLeft: '4px solid #52c41a' }}>
          <div style={{ color: '#999', fontSize: 12 }}>总积分</div>
          <div style={{ fontSize: 24, fontWeight: 600 }}>{totalPoints.toLocaleString()}</div>
        </div>
      </div>

      <input
        type="text"
        placeholder="搜索姓名/家长姓名/手机号..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ width: '100%', maxWidth: 360, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, marginBottom: 20, fontSize: 14 }}
      />

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#fafafa' }}>
              <th style={th}>姓名</th>
              <th style={th}>年龄</th>
              <th style={th}>性别</th>
              <th style={th}>学校/班级</th>
              <th style={th}>家长</th>
              <th style={th}>手机</th>
              <th style={th}>积分</th>
              <th style={th}>机构</th>
              <th style={th}>注册时间</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(c => {
              const pts = pointsMap[c.id]
              return (
                <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ ...td, fontWeight: 500 }}>{c.name || '-'}</td>
                  <td style={td}>{calcAge(c.birthday)}</td>
                  <td style={td}>{c.gender === 'boy' ? '👦' : c.gender === 'girl' ? '👧' : '-'}</td>
                  <td style={td}>{[c.school, c.class].filter(Boolean).join(' / ') || '-'}</td>
                  <td style={td}>{c.parent_name || '-'}</td>
                  <td style={td}>{c.parent_contact || '-'}</td>
                  <td style={{ ...td, color: '#fa8c16', fontWeight: 600 }}>
                    {pts ? (pts.balance || 0).toLocaleString() : '-'}
                  </td>
                  <td style={{ ...td, fontSize: 12, color: '#888' }}>{c.institution_name || c.institution_id || '-'}</td>
                  <td style={{ ...td, color: '#999', fontSize: 12 }}>{c.created_at ? c.created_at.slice(0, 10) : '-'}</td>
                </tr>
              )
            })}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={9} style={{ ...td, textAlign: 'center', color: '#999', padding: 40 }}>
                  暂无孩子数据，请先在客户管理中添加</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

const statCard = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', flex: 1 }
const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
